import { render, staticRenderFns } from "./UnomiConsole.vue?vue&type=template&id=ed133b6e&scoped=true"
import script from "./UnomiConsole.vue?vue&type=script&lang=js"
export * from "./UnomiConsole.vue?vue&type=script&lang=js"
import style0 from "./UnomiConsole.vue?vue&type=style&index=0&id=ed133b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed133b6e",
  null
  
)

export default component.exports